import React, { useEffect } from 'react'

import { ReactComponent as Success } from '../../../assets/icons/check.svg'
import { ReactComponent as Error } from '../../../assets/icons/close.svg'

import './Item.scss'

const getConf = type => {
  let icon, color

  switch (type) {
    case 'success':
      icon = <Success />
      color = 'green'
      break;

    case 'common':
      color = 'blue'
      break;

    case 'error':
      icon = <Error />
      color = 'red'
      break;
  
    default:
      color = 'blue'
      break;
  }

  return { icon, color }
}

export const Item = ({
  item,
  onClick,
  onDead,
}) => {
  const { type, msg } = item
  const { icon, color } = getConf(type)

  useEffect(() => {
    const timeout = setTimeout(() => {
      onDead()
    }, 4000)

    return () => clearTimeout(timeout)
  }, [onDead])

  return (
    <div
      className={`notification ${ color }`}
      onClick={ onClick }
    >
      { icon && icon }
      <span>
        { msg }
      </span>
    </div>
  )
}